export default "__VITE_ASSET__D59ZC2Ku__"